import api from '../../../api/client';
// components/ReceivablesDashboard.js
import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import Receivables from "./Receivables";
import {ReceivablesAnalytics} from "../../../components/ReceivablesAnalytics";

const ReceivablesDashboard = ({ dateRange, fetchData }) => {
  const [activeTab, setActiveTab] = useState("list");

  return (
     <div className="mt-4">
      <Tabs
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        className="mb-3"
      >
        <Tab eventKey="list" title="Receivables List">
          <Receivables dateRange={dateRange} fetchData={fetchData} />
        </Tab>
        <Tab eventKey="analytics" title="Analytics & Reports">
          <ReceivablesAnalytics dateRange={dateRange} fetchData={fetchData} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default ReceivablesDashboard;